// Porta leve (A06): só manifesto, busca e catálogo entram no JS inicial; as telas vêm por import().
export { creditProductListScreen, creditProductDetailScreen } from './credit-product.screen';
export { creditProductListSearch, creditProductDetailSearch } from './credit-product.search';
export { loadCreditProductMessages } from './credit-product.catalog';
export const loadCreditProductScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadCreditProductGuides = () => import('./credit-product.guide');
